import { createClient } from '@supabase/supabase-js';

const hostname = window.location.hostname;

const SUPABASE_CONFIG = hostname === 'flow.wandawazi.com'
    ? {
        url: 'https://axwwgevuksybcnxqqhzf.supabase.co',
        anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF4d3dnZXZ1a3N5YmNueHFxaHpmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU2Nzc2NzMsImV4cCI6MjA4MTI1MzY3M30.ulO6B0iQdJlUbne6gkUSslF_u8q7Lby5OxJvsiSwftg',
    }
    : hostname === 'stage.flow.wandawazi.com'
    ? {
        url: 'https://btjfguwoiewmmgioioyf.supabase.co',
        anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ0amZndXdvaWV3bW1naW9pb3lmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ1MzUzNTYsImV4cCI6MjA5MDExMTM1Nn0.1-MVBSY7NOKMxV51IyIGRg9OEFIsHogUCgHM8DAaJC0',
    }
    : {
        // localhost
        url: 'https://btjfguwoiewmmgioioyf.supabase.co',
        anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ0amZndXdvaWV3bW1naW9pb3lmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ1MzUzNTYsImV4cCI6MjA5MDExMTM1Nn0.1-MVBSY7NOKMxV51IyIGRg9OEFIsHogUCgHM8DAaJC0',
    };

export const supabase = createClient(SUPABASE_CONFIG.url, SUPABASE_CONFIG.anonKey);

export function getResetPasswordRedirectUrl() {
    if (hostname === 'flow.wandawazi.com') return 'https://flow.wandawazi.com/reset-password';
    if (hostname === 'stage.flow.wandawazi.com') return 'https://stage.flow.wandawazi.com/reset-password';
    return 'http://localhost:3000/reset-password';
}
